<template>
  <BaseFiltersSideBar
    v-model="model"
    @filters-submit="onFiltersSubmit"
  >
    <ProjectListFiltersForm
      ref="project-list-filters-form"
      v-model="filters"
      @submit="onFiltersSubmit"
    />
  </BaseFiltersSideBar>
</template>

<script>
import BaseFiltersSideBar from '@/components/ui/sidebar/BaseFiltersSideBar.vue'
import ProjectListFiltersForm from '@/components/projects/form/ProjectListFiltersForm.vue'

export default {
  name: 'ProjectListFilters',
  components: { ProjectListFiltersForm, BaseFiltersSideBar },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filters: {},
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    onFiltersSubmit() {
      this.model = false
      this.$emit('filters-submit', this.filters)
    },
    clearFilters() {
      this.$refs['project-list-filters-form'].clearForm()
    },
  },
}
</script>

<style scoped>
</style>
